import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { INFO_USER } from './constants';
import {
  InfoUserSuccess,
  InfoUserError,
  InfoUserDataActionTypes,
  InfoUserState,
} from './types';

const initialState: InfoUserState = {
  status: idle,
  entities: null,
  error: null,
};

export default produce(
  (draft = initialState, action: InfoUserDataActionTypes): InfoUserState => {
    switch (action.type) {
      case INFO_USER + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case INFO_USER + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as InfoUserSuccess).payload;
        break;
      }
      case INFO_USER + FAILURE: {
        draft.status = rejected;
        draft.error = (action as InfoUserError).error;
        break;
      }
      case INFO_USER + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
